/**
 * Set refresh fetching to TRUE
 */
export function setTrue(key) {
    return {
        type: 'REFRESH_FETCH_TRUE',
        payload: {
            key: key
        }
    };
}

/**
 * Set refresh fetching to FALSE
 */
export function setFalse(key) {
    return {
        type: 'REFRESH_FETCH_FALSE',
        payload: {
            key: key
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/refresh.js